import { InboxOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { useSetState } from 'ahooks'
import { Button, message, Upload, Modal } from 'antd'
import { get, isArray } from 'lodash-es'
import { useEffect } from 'react'
import {
  // getToken, baseURL,
  useFileUrlPrefix,
  CustomFileUpload,
} from 'shj-utils'
import request, { METHODS } from '@/api'
import styles from './index.module.less'

const { Dragger } = Upload

export const customUpload = new CustomFileUpload({
  request,
  message,
  url: '/file-web/file/upload',
})

export enum AcceptType {
  picture = '.png,.jpg,.jpeg,.gif,.webp',
  files = 'application/vnd.ms-excel,aplication/zip,application/msword,application/vnd.ms-powerpoint,application/vnd.ms-excel,text/plain,application/vnd.ms-works',
  autocad='.dwg,.pdf,.dxf,.dwt',
  pdf='.pdf',
};
// customUpload.bind({ message, request, url: '/api-portal/file/upload' })

function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const ImageUpload = (props: any) => {
  const { limit = 8, onChange, fileList, onPreview, type, ...rest } = props
  const [state, setState] = useSetState({
    fileList: [],
    previewImage: '',
    previewVisible: false,
    previewTitle: '',
  })

  const [imagePrefix] = useFileUrlPrefix()

  useEffect(() => {
    if (fileList) {
      setState({ fileList })
    }
  }, [props.fileList])

  useEffect(() => {
    if (Array.isArray(props.value)) {

      setState({ fileList: props.value })
    }
  }, [props.value])

  const handlePreview = async (file: any) => {
    if (isNonPreviewableFile(file)) {
      // 如果是不可预览的文件，则触发下载
      window.open(file.url || file.preview, '_blank');
    } else {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      onPreview && onPreview(file);
      setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
        previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
    }
  };
  
  const handleChange = ({ file, fileList }: any) => {
    if (file.status === 'done') {
      if (props.setFileUrl) {
        fileList = props.setFileUrl && props.setFileUrl(fileList)
      } else {
        fileList = fileList.map((d: any) => {
          if (d.response?.data) {
            if (isArray(d.response?.data)) {
              d.url = imagePrefix + d.response?.data[0]
            } else {
              d.url = imagePrefix + d.response?.data?.filePath;
            }
          }
          return d
        })
      }
    }
    setState({ fileList })
    // console.log('fileList', fileList, file.status)
    if (['removed', 'done'].includes(file.status)) {
      // console.logList(fileList.map((d: any) => d.response.data[0]));
      onChange && onChange(fileList)
    }
  }

  const uploadButton =
    props.listType === 'text' ? (
      <Button icon={<UploadOutlined />}>上传附件</Button>
    ) : (
        <div className={styles.uploadButton} style={{backgroundImage: `url(${props?.exampleImgSrc || ""})`}}>
          <div>
            <PlusOutlined/>
            <div style={{marginTop: 8}}>上传</div>
          </div>
        </div>

    )
// 添加新的辅助函数
const isNonPreviewableFile = (file: any) => {
  const nonPreviewableExtensions = ['.doc', '.docx', '.pdf', '.xls', '.xlsx', '.zip', '.ppt', '.pptx', '.dwg', '.dxf', '.dwt'];
  const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
  return nonPreviewableExtensions.includes(fileExtension);
}
  // const actionOrigin =
  //   process.env.NODE_ENV === 'development' ? window.rawWindow?.location?.origin || '' : ''
  const uploadProps = {
    // action: actionOrigin + baseURL + '/api-portal/file/upload',
    customRequest: customUpload.upload,
    listType: 'picture-card',
    fileList: state.fileList,
    onPreview: props.listType === 'text' ? null : handlePreview,
    onChange: handleChange,
    // headers: {
    //   Authorization: getToken(),
    // },
    disabled: props.readonly,
    accept: rest.acceptType ?? null,
    ...rest,
  }

  const handleCancel = () => {
    setState({ previewVisible: false })
  }

  return (
      <div className={styles.ImageUpload}>
      {type === 'dragger' ? (
        <Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{rest?.tipTex ?? '点击上传图片'}</p>
          {rest?.superTip && <p className="ant-upload-hint">{rest?.superTip}</p>}
        </Dragger>
      ) : (
        <Upload {...uploadProps}>
          {state.fileList.length >= limit || props.readonly ? null : props.children || uploadButton}
        </Upload>
      )}
      <Modal title="预览" open={state?.previewVisible} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: '100%' }} src={state?.previewImage} />
      </Modal>
    </div>
  )
}

export const fileImport = (
  request: Function,
  url: any,
  { file, onSuccess, onError, showMsg = true }: any = {}
) => {
  const data = new FormData()
  data.append('file', file)
  return request(url, { method: METHODS.POST, data, raw: true })
    .then((res: any) => {
      onSuccess && onSuccess()
      const msg = get(res, 'data.message')
      if (showMsg) {
        if (msg) {
          if (res.status === 200) {
            message.success(msg)
          } else {
            message.error(msg)
          }
        }
      }
      return res
    })
    .catch(err => {
      onError?.(err)
    })
}

export default ImageUpload
